import { JsonObject, JsonProperty } from 'typescript-json-serializer';

import { FIELD_TYPE } from 'domain/entity/preset/field/fieldType';
import SelectorValue from 'domain/entity/preset/field/selectorValue';
import PresetFormFieldDependency from 'domain/entity/preset/form/presetFormFieldDependency';
import { Typed } from 'adapter/out/serializer';

@JsonObject()
abstract class PresetFormField implements Typed<FIELD_TYPE> {
    @JsonProperty({ required: true }) abstract readonly type: FIELD_TYPE;

    constructor(
        @JsonProperty({ required: true }) readonly key: string,
        @JsonProperty({ required: true }) readonly labelText: string,
        @JsonProperty({ type: PresetFormFieldDependency, required: true }) readonly dataDependsOn: PresetFormFieldDependency[],
        @JsonProperty() readonly footerText?: string
    ) {}
}

export enum SELECTOR_SHOW_AS {
    DROPDOWN = 'DROPDOWN',
    TOGGLE = 'TOGGLE',
}

@JsonObject()
export abstract class AbstractSelectorPresetFormField extends PresetFormField {
    constructor(
        readonly key: string,
        readonly labelText: string,
        readonly dataDependsOn: PresetFormFieldDependency[],
        @JsonProperty() readonly showAs: SELECTOR_SHOW_AS,
        @JsonProperty() readonly pageSize: number,
        readonly footerText?: string,
        @JsonProperty() readonly defaultValues?: SelectorValue[]
    ) {
        super(key, labelText, dataDependsOn, footerText);
    }
}

@JsonObject()
export class SelectorPresetFormField extends AbstractSelectorPresetFormField {
    readonly type = FIELD_TYPE.SELECTOR;
}

@JsonObject()
export class TreeSelectorPresetFormField extends AbstractSelectorPresetFormField {
    readonly type = FIELD_TYPE.TREE_SELECTOR;
}

@JsonObject()
export class PeriodSelectorPresetFormField extends AbstractSelectorPresetFormField {
    readonly type = FIELD_TYPE.PERIOD_SELECTOR;
}

@JsonObject()
export class TextPresetFormField extends PresetFormField {
    readonly type = FIELD_TYPE.TEXT;

    constructor(
        readonly key: string,
        readonly labelText: string,
        readonly dataDependsOn: PresetFormFieldDependency[],
        @JsonProperty({ required: true }) readonly placeholder: string,
        @JsonProperty({ required: true }) readonly maxLength: number,
        readonly footerText?: string
    ) {
        super(key, labelText, dataDependsOn);
    }
}

export const referenceType = new Map<FIELD_TYPE, unknown>([
    [FIELD_TYPE.SELECTOR, SelectorPresetFormField],
    [FIELD_TYPE.TREE_SELECTOR, TreeSelectorPresetFormField],
    [FIELD_TYPE.PERIOD_SELECTOR, PeriodSelectorPresetFormField],
    [FIELD_TYPE.TEXT, TextPresetFormField],
]);

export default PresetFormField;
